/**
 * Inquiros brand tokens for first-party pages (ops console, demo pages).
 * Mirrors pdf-remediation/public/styles.css so every Inquiros surface reads
 * as one product. The embedded widget keeps per-tenant theming (lib/theme.js)
 * and must never import this.
 */

export const BRAND = {
  ink900: '#281934',   // brand dark purple: headings, primary buttons
  ink700: '#3A2550',   // ink900 hover
  blue: '#2563EB',     // links, focus
  sky: '#0EA5E9',      // accent
  skyLight: '#38BDF8', // accent gradient start
  canvas: '#F8FAFC',   // page background
  surface: '#FFFFFF',
  rule: '#E2E8F0',     // borders
  gray600: '#475569',
  gray500: '#64748B',
  gray400: '#94A3B8',
  gray300: '#CBD5E1',  // input borders
  danger: '#DC2626',
};

export const brandFont =
  "'DM Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif";

/** 48x4 gradient bar used above page titles (the pdf-remediation hero rule). */
export const heroRule = {
  width: '48px',
  height: '4px',
  background: `linear-gradient(90deg, ${BRAND.skyLight}, ${BRAND.sky})`,
  borderRadius: '2px',
  marginBottom: '18px',
};
